import { render } from "./WaitingResponse.vue?vue&type=template&id=4445ff74"
import script from "./WaitingResponse.vue?vue&type=script&lang=js"
export * from "./WaitingResponse.vue?vue&type=script&lang=js"

import exportComponent from "/Users/davidchou/Documents/Programming/vue/cvicloud-app-states-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__